/**
    *
    *
    * @param {{ data: Object }} message
    * @return {Object} 
    */
export function stateInstance(data={}){
  const data1 = JSON.parse(JSON.stringify(data))
  let obj = {
    ...data1,
  }
  const reset = function(){
    const data2 = JSON.parse(JSON.stringify(data))
    let obj1 = {
      ...obj,
      ...data2,
    }
    Object.assign(obj,obj1)
  }
  obj.reset = reset.bind(obj)
  return obj
}